module.exports = __webpack_public_path__ + "static/media/3.bc5c078a.png";